var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [用户信息]
 */
import decode from 'jwt-decode';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumBusiness, EnumCooperateType, EnumPartnerTier, EnumUserType, } from '../../enums';
import { Regulars } from '../../libraries';
import { onCreateFactoryAuth } from './auth';
import { onCreateFactoryUser } from './userModel';
let UserInfoController = class UserInfoController {
    constructor() {
        /**
         * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
         * 除非是地址栏解析或者其他方式等等
         * @memberof SystemController
         */
        this.Auth = onCreateFactoryAuth();
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = onCreateFactoryUser();
    }
    get token() {
        return this.Auth.AccessToken;
    }
    /**
     * token 解析
     * @readonly
     * @memberof SystemController
     */
    get decodeToken() {
        try {
            if (this.Auth.AccessToken) {
                return decode(this.Auth.AccessToken);
            }
        }
        catch (error) {
            console.error(error);
        }
        return {};
    }
    /** 用户身份类型 */
    get aud() {
        return lodash.get(this.decodeToken, 'aud', '');
    }
    /** 用户名 */
    get username() {
        return lodash.get(this.decodeToken, 'username', '');
    }
    /** 身份id */
    get identityId() {
        return (lodash.get(this.decodeToken, 'identityId', '') ||
            lodash.get(this.decodeToken, 'identityIds', ''));
    }
    /** 姓名 */
    get realName() {
        return lodash.get(this.User.value, 'realName', '');
    }
    /** 手机号 */
    get mobile() {
        return lodash.get(this.User.value, 'mobile', '');
    }
    /** 邮箱 */
    get email() {
        return lodash.get(this.User.value, 'email', '');
    }
    /** userid */
    get userId() {
        return lodash.get(this.User.value, 'userId');
    }
    /** 当前身份集合 */
    get currentIdentityVOList() {
        return lodash.get(this.User.value, 'currentIdentityVOList', []);
    }
    /** 角色 */
    get role() {
        return lodash.join(lodash.map(this.currentIdentityVOList, 'roleIdContent'), ',');
    }
    /** 渠道编码 */
    get channelId() {
        return lodash.get(this.User.value, 'channelId', '');
    }
    /** 渠道名称 */
    get channelName() {
        return lodash.get(this.User.value, 'channelName', '');
    }
    /** 是否需要选择身份 */
    get optionIdentity() {
        return lodash.eq(lodash.get(this.User.value, 'optionIdentity'), true);
    }
    // 是否认证
    get isAttestation() {
        return lodash.get(this.User.value, 'verifiedStatus', false);
    }
    /** 渠道等级 */
    get partnerTier() {
        return lodash.get(this.User.value, 'partnerTier', '');
    }
    /**bu是SMB 并且 typeId为19 是商用服务商 是T1（特殊身份）*/
    get isTypeId19() {
        return lodash.some(this.channelTypeList, (channel) => {
            return lodash.eq(lodash.get(channel, 'typeId'), '19');
        });
    }
    /**bu是SMB 并且 typeId为16 是增值经销商 */
    get isHasVars() {
        return lodash.some(this.channelTypeList, (channel) => {
            return lodash.eq(lodash.get(channel, 'typeId'), '16');
        });
    }
    //是否T1身份
    get isT1() {
        if (this.isSMB && this.isTypeId19) {
            return true;
        }
        return lodash.eq(this.partnerTier, EnumPartnerTier.T1);
    }
    //是否T2身份
    get isT2() {
        if (this.isSMB && this.isTypeId19) {
            return true;
        }
        return lodash.eq(this.partnerTier, EnumPartnerTier.T2);
    }
    //是否服务站账号
    get isServiceStation() {
        return lodash.eq(this.partnerTier, EnumPartnerTier.ServiceStation);
    }
    //partnerTier是1
    get isPartnerTierEqT1() {
        return lodash.eq(this.partnerTier, EnumPartnerTier.T1);
    }
    //是否L2
    get isL2() {
        return this.isPartnerTierEqT1;
    }
    //是否L2，10位或者12位账号登录
    get is10Or12LoginL2() {
        return (this.is10Or12Login && lodash.eq(this.partnerTier, EnumPartnerTier.T1));
    }
    //是否L2，手机号登录
    get isMobileL2() {
        return (this.isMobileLogin && lodash.eq(this.partnerTier, EnumPartnerTier.T1));
    }
    //是否SI
    get isSI() {
        return (lodash.eq(this.partnerTier, EnumPartnerTier.T1) && this.isRegisterPartner);
    }
    // 是否认证或加入组织
    get isAuth() {
        return this.identityId && this.isAttestation;
    }
    /** 是否完善信息 */
    get isPerfectInfo() {
        return this.realName;
    }
    /** 是否完善信息 */
    get isRealNameAddress() {
        if (this.isKCodeLogin) {
            return this.realName;
        }
        return this.realName && !lodash.isEmpty(this.userAddress);
    }
    /** 是否签约 */
    get isSign() {
        return lodash.some(this.currentIdentityVOList, { signingStatus: true });
    }
    /**
     * 是否k码登录
     */
    get isKCodeLogin() {
        return lodash.startsWith(lodash.toLower(this.username), lodash.toLower('k'));
    }
    /**
     * 是否D码登录
     */
    get isDCodeLogin() {
        return lodash.startsWith(lodash.toLower(this.username), lodash.toLower('d'));
    }
    /**
     * 是否K或者D码登录
     */
    get isKorDLogin() {
        return this.isKCodeLogin || this.isDCodeLogin;
    }
    /**
     * 是否手机号登录
     */
    get isMobileLogin() {
        return Regulars.mobile_phone.test(this.username);
    }
    /**
     * 是否10位账号登录
     */
    get is10Login() {
        return (Regulars.number.test(this.username) && lodash.size(this.username) == 10);
    }
    /**
     * 是否12位账号登录
     */
    get is12Login() {
        return (Regulars.number.test(this.username) && lodash.size(this.username) == 12);
    }
    /**
     * 是否10位或者12位账号登录
     */
    get is10Or12Login() {
        return this.is10Login || this.is12Login;
    }
    /** 是否 可以操作商机 SMB & 合作伙伴 & level3 或 level4*/
    get isBusiness() {
        return (this.isSMB &&
            this.isCooperativePartner &&
            (this.isLevel3 || this.isLevel4));
    }
    // 是否是管理员
    get isAdmin() {
        const adminIdList = this.isL2
            ? ['582']
            : ['111', '119', '159', '161', '236'];
        if (!this.role)
            return false;
        const roleList = lodash.map(this.role.split(','), (e) => {
            return lodash.includes(adminIdList, e);
        });
        return lodash.some(roleList, Boolean);
    }
    // b码
    get businessCode() {
        return lodash.get(this.User.value, 'companyCoreResponse.businessCode', '');
    }
    // 用户地址
    get userAddress() {
        return lodash.get(this.User.value, 'userAddress', '');
    }
    /** 是否是多个身份 */
    get isMultipleIndentity() {
        return lodash.size(lodash.get(this.User.value, 'indentityList', [])) > 1;
    }
    /** 是否允许切换身份 */
    get isAllowChangeId() {
        return !this.isSales && !this.isKCodeLogin && this.isMultipleIndentity;
    }
    /** BU */
    get BU() {
        return lodash.get(this.User.value, 'businessType', '');
    }
    /** 是否ISG */
    get isISG() {
        return lodash.eq(this.BU, EnumBusiness.ISG);
    }
    /** 是否是意向isg */
    get isIntendedISG() {
        let intentionBu = lodash.get(this.User.value, 'intentionBu');
        return lodash.eq(intentionBu, EnumBusiness.ISG);
    }
    /** 是否CON */
    get isCON() {
        return lodash.eq(this.BU, EnumBusiness.CON);
    }
    /** 是否REL */
    get isREL() {
        return lodash.eq(this.BU, EnumBusiness.REL);
    }
    /** 是否SMB */
    get isSMB() {
        /** 如果存在意向伙伴等其它身份*/
        // if (this.isIntendedPartner) {
        //   return false;
        // }
        return lodash.eq(this.BU, EnumBusiness.SMB);
    }
    /** ocr审核状态 */
    get ocrCheckStatus() {
        return lodash.get(this.User.value, 'ocrCheckStatus');
    }
    /** SMB企业认证-人工审核状态 */
    get manualReviewStatus() {
        return lodash.get(this.User.value, 'manualReviewStatus');
    }
    /** 是否是游客-除smb 以外的其他游客身份 */
    get isNotSMBTourists() {
        return lodash.isEmpty(this.Auth.AccessToken) && !this.isSMB;
    }
    /** 是否SERVICEB */
    get isSERVICEB() {
        return lodash.eq(this.BU, EnumBusiness.SERVICEB);
    }
    /** companyName 公司名称 */
    get companyName() {
        return (lodash.get(this.User.value, 'companyName') ||
            lodash.get(this.User.value, 'companyCoreResponse.companyName') ||
            '无');
    }
    /** 用户类型 */
    get userType() {
        return this.User.value.userType;
    }
    /** 是否 Sales */
    get isSales() {
        return lodash.eq(this.userType, EnumUserType.Sales);
    }
    /** 是否 意向伙伴 */
    get isIntendedPartner() {
        return lodash.eq(this.userType, EnumUserType.Intention);
    }
    /** 是否 合作伙伴 */
    get isCooperativePartner() {
        return lodash.eq(this.userType, EnumUserType.Cooperation);
    }
    /** 合作类型 */
    get cooperateType() {
        return this.User.value.cooperateType;
    }
    /** 注册伙伴 */
    get isRegisterPartner() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Registered);
    }
    /** 签约伙伴 */
    get isSignPartner() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Signing);
    }
    /** 店面伙伴 */
    get isStorePartner() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Store);
    }
    /** 店面伙伴byBU */
    get isStorePartnerByBu() {
        return lodash.eq(this.cooperateType, EnumCooperateType.Store) && this.isSMB;
    }
    /** 是否 L2 : 未认证、签约伙伴、未签约*/
    get isLevel2() {
        return !this.isAttestation && this.isSignPartner && !this.isSign;
    }
    /** 是否 L3 : 注册伙伴*/
    get isLevel3() {
        return this.isRegisterPartner;
    }
    /** 是否 L4 ： 签约伙伴、已签约*/
    get isLevel4() {
        return this.isSignPartner && this.isSign;
    }
    /** 是否 可以购买商品 */
    get isBus() {
        if (this.isSales) {
            return false;
        }
        return this.isLevel3 || this.isLevel4;
    }
    /** 是否 SMB TypeId 16,20 显示购物车 */
    get isSMB1620() {
        const isType = lodash.some(this.channelTypeList, (channel) => {
            return lodash.includes(['16', '20'], lodash.get(channel, 'typeId'));
        });
        return this.isSMB && isType;
    }
    /** 用户类型 */
    get resellerType() {
        if (this.isSales) {
            return 'Sales';
        }
        return this.cooperateType || '未认证';
    }
    /**
   用户类型
        mobile null resellerType 签约商 => 签约未绑定手机号
        isAttestation true resellerType null =>认证未绑定k码
    */
    get userDes() {
        if (this.isSales) {
            return 'Sales';
        }
        let cooperateTypeName = '';
        if (this.cooperateType) {
            cooperateTypeName = this.isRegisterPartner ? '注册伙伴' : '签约伙伴';
        }
        if (!this.mobile && this.cooperateType) {
            return cooperateTypeName + '（未绑定手机）';
        }
        if (this.isAttestation && !this.cooperateType) {
            return '已认证（未绑定k码）';
        }
        return cooperateTypeName || '未认证';
    }
    /** 可以查看积分看板  1.注册用户 levelCode = l2  2.resellerType = ‘注册商’ */
    get isShowInte() {
        return this.isSMB && (this.isRegisterPartner || this.isLevel2);
    }
    // 注册用户 积分 levelCode= l2
    // 注册商  积分 商机  resellerType=注册商
    // 签约商  商机 resellerType=签约商
    /** 可以查看商机看板  用户等级为l3或者l4 且 1.resellerType = 签约商 或者 resellerType=注册商 */
    get isShowBusiness() {
        const isL3OrL4 = this.isLevel3 || this.isLevel4;
        const isType = this.isSignPartner || this.isRegisterPartner;
        return this.isSMB && isL3OrL4 && isType;
    }
    // 是否展示销售看板
    get isShowSales() {
        return this.isSMB && (this.isLevel3 || this.isLevel4);
    }
    // 是否展示奖励看板 - 仅签约商可看
    get isShowReward() {
        return this.isSMB && this.isLevel4;
    }
    /** des 登录用户可以查看简单版本的销售看板 - 有饼图   */
    get isShowSimpleSales() {
        // return this.User.value.token && !lodash.eq(this.User.value.resellerType,'签约商')
        return this.isSMB && this.isLevel3;
    }
    /** des  签约商可以查看完整版本销售看板  - 5个比例和 产品线 产品线暂时不做 无饼图*/
    get isShowComplexSales() {
        // return lodash.eq(this.User.value.resellerType,'签约商')
        return this.isSMB && this.isLevel4;
    }
    // 待办：CON和ISG显示
    get isShowTodo() {
        return this.isCON || this.isISG;
    }
    get isShowIndentityAction() {
        return !this.isAttestation || !this.identityId;
    }
    get isShowSignAction() {
        return this.isSMB && this.isSignPartner && !this.isSign;
    }
    // l2 且签约商 所有看板都不可看，提示 您当前帐户信息不完整，请到用户信息处维护个人信息  按钮：用户信息
    get isShowInfoAction() {
        return this.isSMB && this.isLevel2 && this.isSignPartner;
    }
    /** 用户等级 */
    get levelCode() {
        return this.User.value.levelCode || '';
    }
    get id() {
        return lodash.get(this.User.value, 'id', '');
    }
    /** 用户名称 */
    get userName() {
        if (this.Auth.AccessToken) {
            return this.realName || '未设置名称';
        }
        return '请登录';
    }
    /** 头像 */
    get avatarUrl() {
        return lodash.get(this.User.value, 'avatarUrl');
    }
    /** 用户地址 */
    get userExtendDTO() {
        return (lodash.get(this.currentIdentityVOList, '[0].identityDomicileVO', {}) ||
            lodash.get(this.User.value, 'userAddress', {}));
    }
    /** 地址Str */
    get address() {
        if (this.isSales) {
            return ' ';
        }
        const address = lodash
            .compact([
            lodash.get(this.User.value, 'userExtendDTO.province'),
            lodash.get(this.User.value, 'userExtendDTO.city'),
            lodash.get(this.User.value, 'userExtendDTO.district'),
        ])
            .join(' / ') ||
            lodash
                .compact([
                lodash.get(this.User.value, 'userAddress.province'),
                lodash.get(this.User.value, 'userAddress.city'),
                lodash.get(this.User.value, 'userAddress.district'),
            ])
                .join(' / ');
        return address || '未设置地区';
    }
    get isMobile() {
        // 不包含k码的就是手机登陆的
        const username = lodash.toLower(this.username);
        return !lodash.includes(username, 'k');
    }
    /** sales信息 */
    get salesInfo() {
        return this.User.value.salesInfo;
    }
    /** 用户城市码 */
    get cityCode() {
        return lodash.get(this.User.value, 'userAddress.cityCode', '');
    }
    /** 用户当前渠道类型子类型 */
    get channelTypeList() {
        return lodash.flattenDepth(lodash.map(this.currentIdentityVOList, 'channelTypeList'));
    }
    /** 是否SMB注册商 */
    get isSmbRegistrar() {
        let typeObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '20';
        });
        return this.isSMB && !lodash.isEmpty(typeObj);
    }
    /** 是否SMB签约商 */
    get isSmbContractors() {
        let typeObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '16' || ele.typeId == '19';
        });
        return this.isSMB && !lodash.isEmpty(typeObj);
    }
    /** 扩展信息 获取二维码地址 */
    get weChatQrCode() {
        let weChatQrCode = '';
        const extendInfo = lodash.get(this.User.value, 'extendInfo', '');
        if (JSON.stringify(extendInfo) !== '"{}"' && lodash.size(extendInfo) > 0) {
            weChatQrCode = extendInfo[0]?.value;
        }
        return weChatQrCode;
    }
    /** ISG服务商 或者 SMB注册商 */
    get isIsgService() {
        let findIsgObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '12' && ele.subtypeId == '80';
        });
        let fidSmbObj = lodash.find(this.channelTypeList, (ele) => {
            return ele.typeId == '20';
        });
        return !lodash.isEmpty(findIsgObj) || !lodash.isEmpty(fidSmbObj);
    }
    /** 关闭展开的菜单 */
    closeEllipsis() {
        if (this.token) {
            this.User.merge({ ellipsis: false });
        }
    }
    /** 暂开扩展菜单 */
    get unfoldEllipsis() {
        return lodash.get(this.User.value, 'ellipsis', !lodash.isEmpty(this.token));
    }
    /** 战区 */
    get warRegionName() {
        return lodash.get(this.userExtendDTO, 'warRegionName', '');
    }
};
__decorate([
    computed
], UserInfoController.prototype, "token", null);
__decorate([
    computed
], UserInfoController.prototype, "decodeToken", null);
__decorate([
    computed
], UserInfoController.prototype, "aud", null);
__decorate([
    computed
], UserInfoController.prototype, "username", null);
__decorate([
    computed
], UserInfoController.prototype, "identityId", null);
__decorate([
    computed
], UserInfoController.prototype, "realName", null);
__decorate([
    computed
], UserInfoController.prototype, "mobile", null);
__decorate([
    computed
], UserInfoController.prototype, "email", null);
__decorate([
    computed
], UserInfoController.prototype, "userId", null);
__decorate([
    computed
], UserInfoController.prototype, "currentIdentityVOList", null);
__decorate([
    computed
], UserInfoController.prototype, "role", null);
__decorate([
    computed
], UserInfoController.prototype, "channelId", null);
__decorate([
    computed
], UserInfoController.prototype, "channelName", null);
__decorate([
    computed
], UserInfoController.prototype, "optionIdentity", null);
__decorate([
    computed
], UserInfoController.prototype, "isAttestation", null);
__decorate([
    computed
], UserInfoController.prototype, "partnerTier", null);
__decorate([
    computed
], UserInfoController.prototype, "isTypeId19", null);
__decorate([
    computed
], UserInfoController.prototype, "isHasVars", null);
__decorate([
    computed
], UserInfoController.prototype, "isT1", null);
__decorate([
    computed
], UserInfoController.prototype, "isT2", null);
__decorate([
    computed
], UserInfoController.prototype, "isServiceStation", null);
__decorate([
    computed
], UserInfoController.prototype, "isPartnerTierEqT1", null);
__decorate([
    computed
], UserInfoController.prototype, "isL2", null);
__decorate([
    computed
], UserInfoController.prototype, "is10Or12LoginL2", null);
__decorate([
    computed
], UserInfoController.prototype, "isMobileL2", null);
__decorate([
    computed
], UserInfoController.prototype, "isSI", null);
__decorate([
    computed
], UserInfoController.prototype, "isAuth", null);
__decorate([
    computed
], UserInfoController.prototype, "isPerfectInfo", null);
__decorate([
    computed
], UserInfoController.prototype, "isSign", null);
__decorate([
    computed
], UserInfoController.prototype, "isKCodeLogin", null);
__decorate([
    computed
], UserInfoController.prototype, "isDCodeLogin", null);
__decorate([
    computed
], UserInfoController.prototype, "isKorDLogin", null);
__decorate([
    computed
], UserInfoController.prototype, "isMobileLogin", null);
__decorate([
    computed
], UserInfoController.prototype, "is10Login", null);
__decorate([
    computed
], UserInfoController.prototype, "is12Login", null);
__decorate([
    computed
], UserInfoController.prototype, "is10Or12Login", null);
__decorate([
    computed
], UserInfoController.prototype, "isBusiness", null);
__decorate([
    computed
], UserInfoController.prototype, "isAdmin", null);
__decorate([
    computed
], UserInfoController.prototype, "businessCode", null);
__decorate([
    computed
], UserInfoController.prototype, "userAddress", null);
__decorate([
    computed
], UserInfoController.prototype, "isMultipleIndentity", null);
__decorate([
    computed
], UserInfoController.prototype, "isAllowChangeId", null);
__decorate([
    computed
], UserInfoController.prototype, "BU", null);
__decorate([
    computed
], UserInfoController.prototype, "isISG", null);
__decorate([
    computed
], UserInfoController.prototype, "isIntendedISG", null);
__decorate([
    computed
], UserInfoController.prototype, "isCON", null);
__decorate([
    computed
], UserInfoController.prototype, "isREL", null);
__decorate([
    computed
], UserInfoController.prototype, "isSMB", null);
__decorate([
    computed
], UserInfoController.prototype, "ocrCheckStatus", null);
__decorate([
    computed
], UserInfoController.prototype, "manualReviewStatus", null);
__decorate([
    computed
], UserInfoController.prototype, "isNotSMBTourists", null);
__decorate([
    computed
], UserInfoController.prototype, "isSERVICEB", null);
__decorate([
    computed
], UserInfoController.prototype, "companyName", null);
__decorate([
    computed
], UserInfoController.prototype, "userType", null);
__decorate([
    computed
], UserInfoController.prototype, "isSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isIntendedPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isCooperativePartner", null);
__decorate([
    computed
], UserInfoController.prototype, "cooperateType", null);
__decorate([
    computed
], UserInfoController.prototype, "isRegisterPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isSignPartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isStorePartner", null);
__decorate([
    computed
], UserInfoController.prototype, "isStorePartnerByBu", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel2", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel3", null);
__decorate([
    computed
], UserInfoController.prototype, "isLevel4", null);
__decorate([
    computed
], UserInfoController.prototype, "isBus", null);
__decorate([
    computed
], UserInfoController.prototype, "isSMB1620", null);
__decorate([
    computed
], UserInfoController.prototype, "resellerType", null);
__decorate([
    computed
], UserInfoController.prototype, "userDes", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowInte", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowBusiness", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowReward", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowSimpleSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowComplexSales", null);
__decorate([
    computed
], UserInfoController.prototype, "isShowTodo", null);
__decorate([
    computed
], UserInfoController.prototype, "levelCode", null);
__decorate([
    computed
], UserInfoController.prototype, "id", null);
__decorate([
    computed
], UserInfoController.prototype, "userName", null);
__decorate([
    computed
], UserInfoController.prototype, "avatarUrl", null);
__decorate([
    computed
], UserInfoController.prototype, "userExtendDTO", null);
__decorate([
    computed
], UserInfoController.prototype, "address", null);
__decorate([
    computed
], UserInfoController.prototype, "isMobile", null);
__decorate([
    computed
], UserInfoController.prototype, "salesInfo", null);
__decorate([
    computed
], UserInfoController.prototype, "cityCode", null);
__decorate([
    computed
], UserInfoController.prototype, "channelTypeList", null);
__decorate([
    computed
], UserInfoController.prototype, "isSmbRegistrar", null);
__decorate([
    computed
], UserInfoController.prototype, "isSmbContractors", null);
__decorate([
    computed
], UserInfoController.prototype, "weChatQrCode", null);
__decorate([
    computed
], UserInfoController.prototype, "unfoldEllipsis", null);
__decorate([
    computed
], UserInfoController.prototype, "warRegionName", null);
UserInfoController = __decorate([
    BindAll()
], UserInfoController);
export { UserInfoController };
